// @flow

import type { JSONValue } from 'common/types';
import { withDefault, array, items } from 'common/json/extract';

export default function resources<V>(
  resource: JSONValue => V
): JSONValue => Array<V> {
  return withDefault(array(items(resource)), []);
}
